module.exports = __webpack_public_path__ + "static/img/暂无配送地址icon@2x@3x.b35a666.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/购物车/暂无配送地址icon@2x@3x.png
// module id = HOzu
// module chunks = 192